export default function LoadingPanel({ isLoading }: { isLoading: boolean }) {
  if (!isLoading) {
    return <div />;
  }

  return (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );
}
